import {
  FaChartBar,
  FaBoxOpen,
  FaWallet,
  FaClipboardList,
  FaShieldAlt,
  FaChartLine,
} from "react-icons/fa";

const services = [
  {
    icon: FaClipboardList,
    title: "Accurate Sales & Purchase Records",
    description:
      "Track every sale and purchase in real-time. Get daily, weekly, monthly, and annual profit and loss reports with complete accuracy.",
  },
  {
    icon: FaBoxOpen,
    title: "Inventory Intelligence",
    description:
      "Identify fast-moving goods versus slow-moving stock. Know exactly what sells and what stays on the shelf too long.",
  },
  {
    icon: FaWallet,
    title: "Capital vs. Profit Separation",
    description:
      "Clearly distinguish between your initial capital investment and actual profit generated, so you never accidentally spend your capital.",
  },
  {
    icon: FaChartBar,
    title: "Real-Time Financial Reporting",
    description:
      "Access profit and loss data instantly whenever you need it. Make informed decisions without waiting for end-of-month reports.",
  },
  {
    icon: FaShieldAlt,
    title: "Shrinkage & Loss Prevention",
    description:
      "Every product is accounted for. Detect unrecorded sales, missing stock, and prevent both internal and external theft.",
  },
  {
    icon: FaChartLine,
    title: "Business Performance Visibility",
    description:
      "See the overall trend and health of your business at a glance. Understand whether your shop is growing, stable, or declining.",
  },
];

export function ServicesSection() {
  return (
    <section className="bg-gradient-to-b from-gray-50 to-gray-100 py-24">
      <div className="max-w-[1500px] mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="text-center mb-16">
          {/* Our Services Badge */}
          <div className="inline-block mb-4">
            <span className="bg-white text-blue-800 text-sm font-semibold px-4 py-2 rounded-full border border-blue-600">
              OUR SERVICES
            </span>
          </div>

          {/* Heading */}
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            <span className="text-blue-800">Every </span>
            <span className="text-orange-500">Challenge, </span>
            <span className="text-gray-900">Solved</span>
          </h2>

          {/* Description */}
          <p className="text-gray-600 md:text-xl mt-4 max-w-3xl mx-auto text-lg leading-relaxed">
            Shop Kiganjani addresses the six most critical challenges facing
            shop owners today. Each feature is designed to turn a common pain
            point into a competitive advantage.
          </p>
        </div>

        {/* Grid */}
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {services.map((service) => {
            const Icon = service.icon;

            return (
              <div
                key={service.title}
                className="group bg-white rounded-xl p-6 leading-relaxed shadow-md border border-gray-200 flex flex-col min-h-[340px] transition-all duration-300 hover:shadow-xl relative overflow-hidden"
              >
                {/* Top border on hover */}
                <div className="absolute top-0 left-0 right-0 h-0 bg-gradient-to-r from-blue-500 to-blue-800 transition-all duration-300 group-hover:h-1"></div>

                {/* Header */}
                <div className="flex items-start gap-4 mb-5">
                  {/* Icon with border */}
                  <div className="w-14 h-14 flex items-center justify-center rounded-lg bg-gradient-to-br from-blue-50 to-blue-100 text-blue-800 flex-shrink-0 border-2 border-blue-400 shadow-md group-hover:border-blue-800 group-hover:shadow-lg transition-all duration-300">
                    <Icon size={24} />
                  </div>

                  {/* Title */}
                  <h3 className="text-xl md:text-2xl font-bold text-gray-800 leading-snug group-hover:text-gray-900 transition-colors duration-300">
                    {service.title}
                  </h3>
                </div>

                {/* Description */}
                <div className="bg-gray-50/60 rounded-lg p-5 text-gray-600 md:text-xl leading-relaxed flex-1 border border-gray-300 shadow-inner">
                  <p className="text-lg md:text-xl">{service.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
